import './NoAdAccountFound.scss';

import {
    faBuilding,
    faCheckCircle,
    faCreditCard,
    faExclamationTriangle,
    faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';

function NoAdAccountFound({ onRefresh }) {
    const [showGuide, setShowGuide] = useState(false);

    const steps = [
        {
            number: 1,
            title: 'Acesse o Gerenciador de Anúncios',
            description: 'Clique no botão abaixo para abrir o Facebook Ads Manager',
            action: {
                text: 'Abrir Gerenciador de Anúncios',
                url: 'https://business.facebook.com/adsmanager',
                icon: faExternalLinkAlt
            }
        },
        {
            number: 2,
            title: 'Crie uma Conta de Anúncios',
            description: 'No Gerenciador de Anúncios, clique em "Criar conta de anúncios"',
            details: [
                'Clique no menu de configurações (⚙️)',
                'Selecione "Contas de anúncios"',
                'Clique em "+ Adicionar" → "Criar uma nova conta de anúncios"',
                'Preencha o nome da conta (ex: "Meu Salão - Anúncios")',
                'Selecione o fuso horário: "America/Sao_Paulo"',
                'Selecione a moeda: "BRL (R$)"'
            ]
        },
        {
            number: 3,
            title: 'Adicione uma Forma de Pagamento',
            description: 'Configure seu método de pagamento para ativar a conta',
            action: {
                text: 'Configurar Pagamento',
                url: 'https://business.facebook.com/billing_hub/payment_settings',
                icon: faCreditCard
            },
            details: [
                'Acesse "Configurações de pagamento"',
                'Clique em "Adicionar forma de pagamento"',
                'Escolha: Cartão de crédito/débito ou Boleto bancário',
                'Preencha os dados solicitados',
                'Confirme e salve'
            ]
        },
        {
            number: 4,
            title: 'Atualize a Página',
            description: 'Após criar a conta e adicionar o pagamento, clique em "Atualizar" abaixo',
            action: {
                text: 'Atualizar Dados',
                onClick: () => {
                    setShowGuide(false);
                    onRefresh();
                },
                icon: faCheckCircle,
                variant: 'success'
            }
        }
    ];

    return (
        <>
            <div className="no-ad-account-container">
                <div className="no-ad-account-card">
                    <div className="warning-icon">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                    </div>

                    <h3 className="warning-title">
                        Nenhuma Conta de Anúncios Encontrada
                    </h3>

                    <p className="warning-description">
                        Para criar anúncios no Facebook e Instagram, você precisa ter uma 
                        <strong> Conta de Anúncios</strong> configurada e uma 
                        <strong> forma de pagamento</strong> cadastrada.
                    </p>

                    <div className="warning-actions">
                        <button
                            className="btn-guide"
                            onClick={() => setShowGuide(true)}
                        >
                            <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '8px' }} />
                            Como Criar Conta de Anúncios
                        </button>

                        <button
                            className="btn-refresh"
                            onClick={onRefresh}
                        >
                            🔄 Atualizar
                        </button>
                    </div>

                    <div className="info-box">
                        <strong>💡 Dica:</strong> O processo leva apenas alguns minutos e é totalmente gratuito. 
                        Você só paga quando seus anúncios estiverem ativos.
                    </div>
                </div>
            </div>

            {/* Modal com Guia Passo a Passo */}
            <Modal 
                show={showGuide} 
                onHide={() => setShowGuide(false)} 
                size="lg"
                centered
                className="ad-account-guide-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '12px', color: '#667eea' }} />
                        Como Criar uma Conta de Anúncios
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="guide-intro">
                        <p>
                            Siga este guia passo a passo para criar sua conta de anúncios 
                            e começar a anunciar no Facebook e Instagram.
                        </p>
                    </div>

                    <div className="guide-steps">
                        {steps.map((step) => (
                            <div key={step.number} className="guide-step">
                                <div className="step-header">
                                    <div className="step-number">{step.number}</div>
                                    <div className="step-content">
                                        <h4 className="step-title">{step.title}</h4>
                                        <p className="step-description">{step.description}</p>
                                    </div>
                                </div>

                                {step.details && (
                                    <ul className="step-details">
                                        {step.details.map((detail, index) => (
                                            <li key={index}>{detail}</li>
                                        ))}
                                    </ul>
                                )}

                                {step.action && (
                                    <div className="step-action">
                                        {step.action.url ? (
                                            <a
                                                href={step.action.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={`btn-step ${step.action.variant || 'primary'}`}
                                            >
                                                <FontAwesomeIcon icon={step.action.icon} style={{ marginRight: '8px' }} />
                                                {step.action.text}
                                            </a>
                                        ) : (
                                            <button
                                                onClick={step.action.onClick}
                                                className={`btn-step ${step.action.variant || 'primary'}`}
                                            >
                                                <FontAwesomeIcon icon={step.action.icon} style={{ marginRight: '8px' }} />
                                                {step.action.text}
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="guide-footer">
                        <div className="help-box">
                            <strong>❓ Precisa de ajuda?</strong>
                            <p>
                                Consulte a{' '}
                                <a 
                                    href="https://www.facebook.com/business/help/407323696966570" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    Central de Ajuda do Facebook
                                </a>
                            </p>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        className="btn-close-modal"
                        onClick={() => setShowGuide(false)}
                    >
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default NoAdAccountFound;